import controller from './kform-builder-list.controller';
import template from './kform-builder-list.html';

const kformBuilderListDirective = () => ({
	scope:    {
		component:       '=',
		form:            '=',
		parent:          '=?',
		hideDndBoxCount: '=',
		rootList:        '=',
		options:         '=',
		data:            '=?',
	},
	restrict: 'E',
	replace:  true,
	controller,
	template,
});

export default kformBuilderListDirective;
